import type { ReactNode } from "react";
import { ThemeProvider } from "next-themes";
import { useLocation } from "react-router-dom";

import { isPublicAuthPath } from "@/constants/auth-public-routes";

type PortalThemeProviderProps = {
  children: ReactNode;
};

export function PortalThemeProvider({
  children,
}: PortalThemeProviderProps): JSX.Element {
  const { pathname } = useLocation();
  const forceLight = isPublicAuthPath(pathname);

  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      storageKey="fiscalo-theme"
      disableTransitionOnChange
      forcedTheme={forceLight ? "light" : undefined}
    >
      {children}
    </ThemeProvider>
  );
}
